'use client';

import { FashButton, MimaText, PageLoader } from '@/components';
import React from 'react';
import styles from '@/assets/styles/pages/competition/competition.module.scss';
import { amountFormatter } from '@/utils/utils';
import { useRouter } from 'next/navigation';
import constant from '@/utils/constant';
import { competitionStore } from '@/stores';
import { CompetitionController } from '@/controllers';

const CompetitionHistory = () => {
  const { data, isLoading } = CompetitionController.useGetWinners();
  const pastCompetitions = (data as any)?.data || [];

  const router = useRouter();

  const handleViewWinners = (item: any) => {
    competitionStore.setSelectedPastCompetition(item);
    router.push(constant.Routes.PastWinners);
  };
  return (
    <>
      {isLoading ? (
        <PageLoader loading={isLoading} title="while we fetch your data" />
      ) : (
        <div className={styles.pastCompetitions}>
          <MimaText variant="subtitleBold" align="center" mb={4}>
            Past Competitions
          </MimaText>
          {pastCompetitions.length < 1 ? (
            <MimaText variant="subtitle">No Record Found</MimaText>
          ) : (
            <>
              {' '}
              {pastCompetitions?.map((item: any) => {
                return (
                  <div key={item._id} className={styles.pastCompetitions_card}>
                    <MimaText variant="subtitleBold" color="var(--color-primary-2)">
                      {item?.competition?.name}
                    </MimaText>
                    <MimaText variant="bodyBold">{item?.competition?.summary}</MimaText>
                    <MimaText variant="bodyBold" mb={1}>
                      Join the competition to win Prizes worth up to{' '}
                      <span>{`${amountFormatter(item?.competition?.currencyCode).format(item?.competition?.winningAmount)}.`} </span>{' '}
                    </MimaText>
                    <FashButton
                      title="View Winners"
                      color="var(--color-primary-2)"
                      icon
                      onClick={() => {
                        handleViewWinners(item);
                      }}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default CompetitionHistory;
